import { usePwaInstallStore } from '@/store'

function isStandalone() {
	return (
		window.matchMedia('(display-mode: standalone)').matches ||
		// Safari iOS não suporta display-mode em versões antigas
		(navigator as Navigator & { standalone?: boolean }).standalone === true
	)
}

function isIos() {
	return (
		/iPad|iPhone|iPod/.test(navigator.userAgent) ||
		// iPadOS se identifica como Mac
		(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
	)
}

export type PwaInstallPlatform = 'native' | 'ios' | null

export function usePwaInstall() {
	const deferredPrompt = usePwaInstallStore((s) => s.deferredPrompt)
	const installed = usePwaInstallStore((s) => s.installed)
	const setDeferredPrompt = usePwaInstallStore((s) => s.setDeferredPrompt)
	const markInstalled = usePwaInstallStore((s) => s.markInstalled)
	const setIosGuideOpen = usePwaInstallStore((s) => s.setIosGuideOpen)

	// 'native': Chrome/Edge/Android oferecem o prompt; 'ios': só instrução manual
	let platform: PwaInstallPlatform = null
	if (!isStandalone() && !installed) {
		if (deferredPrompt) platform = 'native'
		else if (isIos()) platform = 'ios'
	}

	const install = async () => {
		if (platform === 'ios') {
			setIosGuideOpen(true)
			return
		}
		if (!deferredPrompt) return
		await deferredPrompt.prompt()
		const { outcome } = await deferredPrompt.userChoice
		// O prompt só pode ser usado uma vez
		setDeferredPrompt(null)
		if (outcome === 'accepted') markInstalled()
	}

	return { canInstall: platform !== null, platform, install }
}
